export const textInputBgColor = "rgba(0, 0, 0, 0.7)";
